import {ContactUsRequest} from "../../../declarations";
import {axiosPartnerPlatformInstance} from "../../ServerApiManager";
import {AxiosResponse} from "axios";

type Variables = {
  contactUsRequest: ContactUsRequest;
};

type Data = boolean;
export const sendContactUs = async (variables: Variables): Promise<Data> => {
  await axiosPartnerPlatformInstance.post<ContactUsRequest, AxiosResponse<undefined>>(
    `/contact-us`,
    variables.contactUsRequest
  );
  return true;
};
